//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"NumberDelayedParts",0,0]],[[[],"Dispose",{},0,0],[["i"],"GetPartName",{R_:{part_name:''}},1,0],[["i"],"GetDelayedStatus",{R_:{status:''}},1,0]],[]];
SPLM.PartDelayedUpdateStatus = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PartDelayedUpdateStatus";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PartDelayedUpdateStatus.DelayStatusInfo = class{
    constructor(session_delayed,explicit_delayed,frozen_delayed,not_displayed_delayed,deferred_delayed,internal_delayed,constraint_delayed){
        this.session_delayed=session_delayed;this.explicit_delayed=explicit_delayed;this.frozen_delayed=frozen_delayed;this.not_displayed_delayed=not_displayed_delayed;this.deferred_delayed=deferred_delayed;this.internal_delayed=internal_delayed;this.constraint_delayed=constraint_delayed;}
    get SessionDelayed(){return this.session_delayed}
    set SessionDelayed(val){this.session_delayed = val}
    get ExplicitDelayed(){return this.explicit_delayed}
    set ExplicitDelayed(val){this.explicit_delayed = val}
    get FrozenDelayed(){return this.frozen_delayed}
    set FrozenDelayed(val){this.frozen_delayed = val}
    get NotDisplayedDelayed(){return this.not_displayed_delayed}
    set NotDisplayedDelayed(val){this.not_displayed_delayed = val}
    get DeferredDelayed(){return this.deferred_delayed}
    set DeferredDelayed(val){this.deferred_delayed = val}
    get InternalDelayed(){return this.internal_delayed}
    set InternalDelayed(val){this.internal_delayed = val}
    get ConstraintDelayed(){return this.constraint_delayed}
    set ConstraintDelayed(val){this.constraint_delayed = val}
};

export default SPLM;